var map = {
	"./banhanguytin/1.png": "85fb",
	"./cacung/1.png": "91db",
	"./chuyencan/1.png": "8276",
	"./daigiadataha/1.png": "ef33",
	"./duhanhgia/1.png": "9097",
	"./thanhsanma/1.png": "9532"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c7cd";